import { workLogs } from "@/api/logs/useWorksLogsQuery";
import { useLocalStorage } from "@/context/LocalStorageProvider";
import useFetcher from "@/hooks/useFetcher";
import { usePaginationStore } from "@/store/pagenation.store";
import { WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";

export const useWorkLogsFormFetch = () => {
  const { workId } = useLocalStorage();
  const { currentPage } = usePaginationStore((state) => ({
    currentPage: state.currentPage,
  }));
  const { queryKey, queryFn } = workLogs.get({
    query: {
      $and: [
        { workId: { $eq: workId ?? 0 } },
        { parentWorkLogId: { $eq: null } },
        {
          $or: [
            {
              workLogType: {
                $in: [
                  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.DEFECT,
                  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.INPUT,
                  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.PERFORMANCE,
                  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.RECYCLE,
                  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.SPLIT_LOT,
                  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.CORRECTION,
                  WorkLogsGet200ResponseRowsInnerWorkLogTypeEnum.CONSUME,
                ],
              },
            },
          ],
        },
        {
          $or: [
            { description: { $ne: "ACTION" } },
            { description: { $eq: null } },
          ],
        },
      ],
    },
    sort: "-id",
    page: currentPage,
    populate: [
      "itemUnit",
      "defectName",
      "creatorUser",
      "alreadyCanceledWorkLog",
    ],
  });

  // useFetcher를 사용하여 queryKey와 queryFn을 설정
  const { data, Fetcher } = useFetcher({
    queryKey: queryKey,
    queryFn: queryFn,
  });

  return { data, Fetcher };
};
